const translations = {
	confirm: "Confirmer",
	validate: "Valider",
	report_anomaly: "Signaler une errreur",
	continue: "Continuer",
	cancel: "Annuler",
	logout: "Déconnexion",
	consults: "Consulter",
	select: "Sélectionner",
	search: "Rechercher",
	yes: "Oui",
	no: "Non",
	save: "Enregistrer",
	back: "Retour",
	delete: "Supprimer",
	add: "Ajouter",
	next: "Suivant",
	next_page: "Passer à l'étape suivante",
	back_to: "Reprendre",
	close: "Fermer",
	other: "Autre",
	souscripteur1: "Souscripteur 1",
	souscripteur2: "Souscripteur 2",
	civility_cosubscription: "Conjoints",
	results: "Résultats",
	warning: "Attention",
	see_detail: "Voir le détail",
	no_content: "Aucun contenu",
	loading: "Chargement...",
	find_your_address: "Trouvez votre adresse",
	back_to_subscriptions: "Retour aux souscriptions",
	back_to_clients: "Retour aux clients",
	back_to_home: "Retour à l'accueil",
	end: "Fin",
	step: "Étape",
	modify: "Modifier",
	not_valid_client: "Ce client contient des informations invalides ou incomplètes pour entamer une souscription. \n\n Sélectionnez-le pour le compléter",
	modify_informations: "Modifier les informations",
	save_informations: "Enregistrer les informations",
	actif: "Actif",
	inactif: "Inactif",
	invite: "Inviter",
	invited: "Invité",
	send: "Envoyer",
	resend_in_5_minutes: "Le mail d'invitation a été envoyé.\n Vous pourrez renvoyer un mail dans 5 minutes",
};

export default translations;
